import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { ColorPicker } from '@openng/optimus-ui/colorpicker';
import { InputText } from '@openng/optimus-ui/inputtext';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface ColorPickerProps extends FieldWrapperProps {
  inline?: boolean;
}

export interface ColorPickerFieldConfig extends FormlyFieldConfig<ColorPickerProps> {
  type?: 'color-picker' | Type<ColorTypeComponent>;
}

@Component({
  selector: 'lib-formly-color-type',
  templateUrl: './color-type.component.html',
  styleUrl: './color-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, ColorPicker, ReactiveFormsModule, FormlyModule, NgClass, InputText]
})
export class ColorTypeComponent extends FieldType<FieldTypeConfig<ColorPickerProps>> {}
